export const COMPATIBLE = 'compatible'
export const CROSS_SELLING = 'cross-selling'

const titles = {
    [COMPATIBLE]: 'Совместимые референсы',
    [CROSS_SELLING]: 'Перекрестные референсы'
}

export const getType = (type) => {
    return titles[type]
}